import "./App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "./context/AuthContext";
import Landing from "./pages/Landing";
import AuthCallback from "./pages/AuthCallback";
import Dashboard from "./pages/Dashboard";
import Generate from "./pages/Generate";
import MyResources from "./pages/MyResources";
import Grading from "./pages/Grading";
import Pricing from "./pages/Pricing";
import { PaymentSuccess, PaymentCancel } from "./pages/PaymentResult";
import ResetPassword from "./pages/ResetPassword";
import { Loader2 } from "lucide-react";

function Protected({ children }) {
  const { user, checked } = useAuth();
  if (!checked)
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#FDFBF7]">
        <Loader2 className="animate-spin text-sky-500" size={40} />
      </div>
    );
  if (!user) return <Navigate to="/" replace />;
  return children;
}

function AppRoutes() {
  const location = useLocation();
  if (location.hash && location.hash.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/app" element={<Protected><Dashboard /></Protected>} />
      <Route path="/app/presentation" element={<Protected><Generate type="presentation" /></Protected>} />
      <Route path="/app/worksheet" element={<Protected><Generate type="worksheet" /></Protected>} />
      <Route path="/app/lesson-plan" element={<Protected><Generate type="lesson-plan" /></Protected>} />
      <Route path="/app/my-resources" element={<Protected><MyResources /></Protected>} />
      <Route path="/app/grading" element={<Protected><Grading /></Protected>} />
      <Route path="/app/pricing" element={<Protected><Pricing /></Protected>} />
      <Route path="/payment/success" element={<PaymentSuccess />} />
      <Route path="/payment/cancel" element={<PaymentCancel />} />
      <Route path="/reset-password" element={<ResetPassword />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <AppRoutes />
          <Toaster position="top-center" richColors />
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
